import { Movement } from '../types/movement';
import { Package } from '../types/package';
import { Flight } from '../types/flight';
import { Pilgrim } from '../types/pilgrim';
import { groupMovements } from './movements/grouping';
import { generateMovementsFromGroups } from './movements/generators';
import {getMovementPilgrims} from './movements/pilgrimMatching';

export const generateMovements = (
  packages: Record<string, Package>,
  flights: Record<string, Flight>, 
  pilgrims: Record<string, Pilgrim>
): Movement[] => {
  // Group movements by their unique characteristics
  const groups = groupMovements(packages, flights, pilgrims);
  
  // Generate movements with correct pilgrim counts
  const movements = generateMovementsFromGroups(groups);

  // Update each movement's pilgrim count based on matching logic
  return movements.map(movement => {
    const matchedPilgrims = getMovementPilgrims(movement, pilgrims, packages, flights);
    return {
      ...movement,
      pilgrimsCount: matchedPilgrims.length // Update the count with actual matched pilgrims
    };
  });
};